import script from "./message-image-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-image-web.vue?vue&type=script&lang=ts&setup=true"

import "./message-image-web.vue?vue&type=style&index=0&id=1e73ef6d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e73ef6d"]])

export default __exports__